import React from 'react';
import { Filter } from 'framework/list';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import LeadNotificationButton from './LeadNotificationButton';

type StaleLeadsResponse = {
  totalElements: number;
};

const StaleLeadsNotificationButton = (props: { state: Filter; response: StaleLeadsResponse }) => {
  const getLabel = ({ totalElements }: StaleLeadsResponse) => {
    const hasSeveralLeads = totalElements > 1;

    return `${totalElements} of yours ${hasSeveralLeads ? 'are' : 'is'} STALE (21+ days without touch)`;
  };

  return (
    <LeadNotificationButton
      getLabel={getLabel}
      icon={<HistoryToggleOffOutlinedIcon sx={{ fontSize: 18, color: 'info.main' }} />}
      accentSoftColor="background.info"
      styles={{
        borderColor: 'info.main',
        '&.Mui-disabled': {
          borderColor: 'info.main',
        },
      }}
      {...props}
    />
  );
};

export default StaleLeadsNotificationButton;
